import Items from './Items'
import Vue from 'vue'

export default {
    name: 'kendo-toolbar-item',
    render () {
        return Vue.prototype._e
    },
    mixins: [
        Items
    ]
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/KendoToolBarItem.js